<template>
  <b-container class="mw-100 mt-3">
    <b-row align-h="center">
      <b-col>
        <b-card class="mt-4 mb-4 mw-100" :body-class="isMobile ? 'p-2' : ''">
          <standard-table ref="vehicleTable"
                          :items="items"
                          :fields="fields"
                          :customFields="customFields"
                          :search-place-holder="`${$tc('message.example', 1)}: AA999ZZ`"

                          :row-search="{cols: 12,sm: 12,md: 12,lg: 4,xl: 4,order: 1,orderSm: 2,orderMd: 2,orderLg: 1,orderXl: 1}"
                          :row-after-search="{cols: 12, sm: 12, md: 12, lg: 8, xl: 8, order: 2, orderSm: 3, orderMd: 3, orderLg: 2, orderXl: 2}"

                          :row-pagination="{cols: 12, sm: 12, md: 6, lg: 5, xl: 5}"
                          :row-between-pagination="{cols: 12, sm: 12, md: 1, lg: 1, xl: 4}"
                          :row-per-page="{cols: 12, sm: 12, md: 5, lg: 3, xl: 2}"
                          :row-after-per-page="{cols: 12, sm: 12, md: 12, lg: 3, xl: 1}"

                          :fixed=isMobile
                          :fullWidth="true"
                          noContainerPadding="true"

                          @rowEdit="$router.push({name: 'EditVehicle', params: {id: $event.item.id}, query: {tab: 'services'}})">
            <template v-for="(field, index) in customFields" :slot="field.key" slot-scope="row">
              <div :key="index">
                <div v-if="!field.isInfo">
                  <font-awesome-icon icon="circle" class="c-green"
                                     v-if="row && row.item && row.item[field.key] !== $tc('message.no', 1)"
                                     v-b-popover.hover.right="$tc('info.hasService', 1)">
                  </font-awesome-icon>
                  <i class="fas fa-circle c-red" v-else  v-b-popover.hover.right="$tc('info.hasNoService', 1)"/>
                  {{row && row.item && row.item[field.key] !== $tc('message.yes', 1) && row.item[field.key] !== $tc('message.no', 1) ? row.item[field.key] : ''}}
                </div>

                <div v-else>
                  {{row && row.item && row.item[field.key] !== $tc('message.yes', 1) && row.item[field.key] !== $tc('message.no', 1) ? row.item[field.key] : ''}}
                </div>
              </div>
            </template>

            <b-container slot="row-after-search" class="mw-100 p-0 ">
              <b-row>
                <b-col cols="auto">
                  <b-button v-on:click="resetFilters()" class="b-c-green" id="reset-filters">
                    {{$t('message.resetFilters')}}
                  </b-button>
                </b-col>

                <b-col cols="auto" class="mb-3">
                  <b-button @click="showCollapse = !showCollapse" :class="showCollapse ? 'b-c-red' : 'b-c-green'">
                    <span v-show="!showCollapse" class="when-opened">{{$t('message.show')}} {{$tc('message.filter', 2).toLowerCase()}}</span>
                    <span v-show="showCollapse" class="when-closed">{{$t('message.hide')}} {{$tc('message.filter', 2).toLowerCase()}}</span>
                  </b-button>
                </b-col>
              </b-row>
            </b-container>

            <b-container :body-class="isMobile ? 'p-2' : ''" slot="after-search" class="mw-100 p-0">
              <b-collapse id="my-collapse" v-model="showCollapse">
                <b-container class="mw-100 m-0 p-0">
                  <b-row>
                    <b-col cols="12" sm="6" md="6" lg="4" xl="4">
                      <b-form-group :label="`${$tc('message.sector', 1)} ${$tc('message.activity', 1).toLowerCase()}`"
                                    label-for="input-activity-sector">
                        <model-list-select id="input-activity-sector"
                                           option-text="text"
                                           option-value="value"
                                           :placeholder="activitySectorOptions && activitySectorOptions.length !== 0 ? $t('message.selectOption') : $t('message.noOption')"
                                           v-model="activitySectorFilter"
                                           :list="activitySectorOptions">
                        </model-list-select>
                      </b-form-group>
                    </b-col>

                    <b-col cols="12" sm="6" md="6" lg="4" xl="4">
                      <b-form-group :label="$tc('message.society', 1)"
                                    label-for="input-corp">
                        <model-list-select id="input-corp"
                                           option-text="text"
                                           option-value="value"
                                           :placeholder="companyOptions && companyOptions.length !== 0 ? $t('message.selectOption') : $t('message.noOption')"
                                           v-model="companyFilter"
                                           :list="companyOptions">
                        </model-list-select>
                      </b-form-group>
                    </b-col>

                    <b-col cols="12" sm="6" md="6" lg="4" xl="4">
                      <b-form-group :label="`${$tc('message.property', 1)}`"
                                    label-for="input-owner">
                        <model-list-select id="input-owner"
                                           option-text="text"
                                           option-value="value"
                                           :placeholder="ownerOptions && ownerOptions.length !== 0 ? $t('message.selectOption') : $t('message.noOption')"
                                           v-model="ownerFilter"
                                           :list="ownerOptions">
                        </model-list-select>
                      </b-form-group>
                    </b-col>
                  </b-row>

                  <b-row>
                    <b-col cols="12" sm="6" md="6" lg="4" xl="4">
                      <b-form-group :label="$t('message.vehicleUsage')"
                                    label-for="input-removegd">
                        <model-list-select id="input-removegd"
                                           option-text="text"
                                           option-value="value"
                                           :placeholder="ownershipTypeOptions && ownershipTypeOptions.length !== 0 ? $t('message.selectOption') : $t('message.noOption')"
                                           v-model="ownershipTypeFilter"
                                           :list="ownershipTypeOptions">
                        </model-list-select>
                      </b-form-group>
                    </b-col>

                    <b-col cols="12" sm="6" md="6" lg="4" xl="4">
                      <b-form-group :label="`${$tc('message.status', 1)} ${$tc('message.vehicle', 1).toLowerCase()}`"
                                    label-for="input-state-vehicle">
                        <model-list-select id="input-state-vehicle"
                                           option-text="text"
                                           option-value="value"
                                           :placeholder="vehicleStateOptions && vehicleStateOptions.length !== 0 ? $t('message.selectOption') : $t('message.noOption')"
                                           v-model="vehicleStateFilter"
                                           :list="vehicleStateOptions">
                        </model-list-select>
                      </b-form-group>
                    </b-col>

                    <b-col cols="12" sm="6" md="6" lg="4" xl="4">
                      <b-form-group :label="$t('message.inOperation')"
                                    label-for="input-removed">
                        <model-list-select id="input-removed"
                                           option-text="text"
                                           option-value="value"
                                           :placeholder="removedOptions && removedOptions.length !== 0 ? $t('message.selectOption') : $t('message.noOption')"
                                           v-model="removedFilter"
                                           :list="removedOptions">
                        </model-list-select>
                      </b-form-group>
                    </b-col>
                  </b-row>

                  <b-row>
                    <b-col cols="12" sm="6" md="6" lg="4" xl="4">
                      <b-form-group :label="$tc('message.vehicleThat', 1)"
                                    label-for="input-possession-service">
                        <model-list-select id="input-possession-service"
                                           option-text="text"
                                           option-value="value"
                                           :placeholder="possessionOptions && possessionOptions.length !== 0 ? $t('message.selectOption') : $t('message.noOption')"
                                           v-model="possessionFilter"
                                           :list="possessionOptions">
                        </model-list-select>
                      </b-form-group>
                    </b-col>

                    <b-col cols="12" sm="6" md="6" lg="4" xl="4">
                      <b-form-group :label="$tc('message.service', 1)"
                                    label-for="input-service">
                        <model-list-select id="input-service"
                                           :isDisabled="possessionFilter === ''"
                                           option-text="text"
                                           option-value="value"
                                           :placeholder="serviceTypeOptions && serviceTypeOptions.length !== 0 ? $t('message.selectOption') : $t('message.noOption')"
                                           v-model="serviceTypeFilter"
                                           :list="serviceTypeOptions">
                        </model-list-select>
                      </b-form-group>
                    </b-col>
                  </b-row>
                </b-container>
              </b-collapse>
            </b-container>

            <b-container :body-class="isMobile ? 'p-2' : ''" slot="row-after-per-page" class="mw-100 p-0">
              <b-row>
                <b-col>
                  <b-button class="float-right mt-3 mt-md-0 mt-lg-0 mt-xl-0"
                            id="excel-button"
                            @click="handleExcel(`${$tc('message.report', 1).toLocaleLowerCase()}_${$tc('message.service', 2).toLocaleLowerCase()}`)">Excel
                  </b-button>
                </b-col>
              </b-row>
            </b-container>
          </standard-table>
        </b-card>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import Vue from 'vue'
import { DateTime } from 'luxon'
import { cloneDeep, filter, find, orderBy, last, keys } from 'lodash'

export default {
  name: 'VehicleServices',
  created () {
    this.fetchData()
  },
  mounted () {
    this.$root.$on('change-lang', () => {
      if (this.$el.isConnected) {
        this.getOptions()
        this.updateLinks()
      }
    })
    this.$root.$on('resize', () => {
      this.checkWindowWidth()
    })
  },
  data () {
    const config = this.$route.meta.config

    return {
      config,
      isMobile: false,
      DateTime,
      fields: [],
      originalItems: [],
      items: [],
      originalVehicles: [],
      customFields: [],
      showCollapse: false,
      // filters
      activitySectorOptions: [],
      activitySectorFilter: '',
      companyOptions: [],
      companyFilter: '',
      ownerOptions: [],
      ownerFilter: '',
      vehicleStateOptions: [],
      vehicleStateFilter: '',
      serviceTypeOptions: [],
      serviceTypeFilter: '',
      ownershipTypeOptions: [],
      ownershipTypeFilter: '',
      wasteOptions: [],
      removedOptions: [],
      removedFilter: '',
      possessionOptions: [],
      possessionFilter: '',
      // other options for excel
      fuelsOptions: [],
      classificationOptions: [],
      equipmentOptions: [],
      links: [
        '/configuration/activity_sector',
        '/configuration/company',
        '/configuration/owner',
        '/configuration/vehicle_state',
        '/configuration/service_type'
      ]
    }
  },
  watch: {
    activitySectorFilter (val) {
      this.items = this.getItems(val, 'activitySectorFilter')
      this.changeFields(null, null, this.items)
    },
    companyFilter (val) {
      this.items = this.getItems(val, 'companyFilter')
      this.changeFields(null, null, this.items)
    },
    ownerFilter (val) {
      this.items = this.getItems(val, 'ownerFilter')
      this.changeFields(null, null, this.items)
    },
    vehicleStateFilter (val) {
      this.items = this.getItems(val, 'vehicleStateFilter')
      this.changeFields(null, null, this.items)
    },
    ownershipTypeFilter (val) {
      this.items = this.getItems(val, 'ownershipTypeFilter')
      this.changeFields(null, null, this.items)
    },
    removedFilter (val) {
      this.items = this.getItems(val, 'removedFilter')
      this.changeFields(null, null, this.items)
    },
    possessionFilter (val) {
      this.items = this.getItems(val, 'possessionFilter')
      this.changeFields(val, 'possessionFilter', this.items)
    },
    serviceTypeFilter (val) {
      this.items = this.getItems(val, 'serviceTypeFilter')
      this.changeFields(val, 'serviceTypeFilter', this.items)
    }
  },
  methods: {
    clickedLink (link) {
      this.$router.push(link.href)
    },
    checkWindowWidth () {
      const size = Vue.myGetWindowSize()
      this.isMobile = (size !== 'md' && size !== 'lg' && size !== 'xl')
    },
    getItems (value, field) {
      const activitySector = field === 'activitySectorFilter' ? value : this.activitySectorFilter
      const company = field === 'companyFilter' ? value : this.companyFilter
      const owner = field === 'ownerFilter' ? value : this.ownerFilter
      const vehicleState = field === 'vehicleStateFilter' ? value : this.vehicleStateFilter
      const ownershipType = field === 'ownershipTypeFilter' ? value : this.ownershipTypeFilter
      const removed = field === 'removedFilter' ? value : this.removedFilter
      const possession = field === 'possessionFilter' ? value : this.possessionFilter
      const service = field === 'serviceTypeFilter' ? value : this.serviceTypeFilter
      let editedItems = cloneDeep(this.originalItems)

      if (activitySector && activitySector !== '') {
        editedItems = filter(editedItems, obj => obj.activitySectorValue === find(this.activitySectorOptions, obj => obj.value === activitySector).value)
      }
      if (company && company !== '') {
        editedItems = filter(editedItems, obj => obj.userCompanyValue === find(this.companyOptions, obj => obj.value === company).value)
      }
      if (owner && owner !== '') {
        editedItems = filter(editedItems, obj => obj.propertyValue === find(this.ownerOptions, obj => obj.value === owner).value)
      }
      if (vehicleState && vehicleState !== '') {
        editedItems = filter(editedItems, obj => obj.stateValue === find(this.vehicleStateOptions, obj => obj.value === vehicleState).value)
      }
      if (ownershipType && ownershipType !== '') {
        editedItems = filter(editedItems, obj => obj.ownershipValue === find(this.ownershipTypeOptions, obj => obj.value === ownershipType).value)
      }
      if (removed !== '') {
        editedItems = filter(editedItems, obj => obj.disabledValue === removed)
      }
      if (possession !== '' && service && service !== '') {
        editedItems = filter(editedItems, obj => {
          return possession ? obj[service] !== this.$tc('message.no', 1) : obj[service] === this.$tc('message.no', 1)
        })
      }
      return editedItems
    },
    changeFields (value, field, vehicles) {
      const possession = field === 'possessionFilter' ? value : this.possessionFilter
      const service = field === 'serviceTypeFilter' ? value : this.serviceTypeFilter
      const services = cloneDeep(this.getServices(vehicles))

      if (possession === true && service !== '') {
        const fields = this.getFields([])
        const filteredVehicles = filter(vehicles, obj => find(obj.services, obj => obj.type === service))
        const newFields = new Set()
        if (filteredVehicles && filteredVehicles.length !== 0) {
          filteredVehicles.forEach(vehicle => {
            vehicle.services.forEach(serviceObj => {
              if (serviceObj.type === service) {
                keys(serviceObj).forEach(field => {
                  if (field !== 'type') {
                    newFields.add(field)
                    vehicle[`foundedService${field}`] = serviceObj[field]
                  }
                })
              }
            })
          })
          const customFields = []
          let firstInjectionColumnIndex = 2
          newFields.forEach(field => {
            customFields.push({
              key: `foundedService${field}`,
              label: this.$tc(`message.${field}`),
              sortable: true,
              sortDirection: 'desc',
              position: firstInjectionColumnIndex,
              isInfo: true
            })
            firstInjectionColumnIndex += 1
          })
          this.fields = fields
          this.customFields = customFields
        }
      } else if (service !== '') {
        if (possession === '') this.serviceTypeFilter = ''
        const editedServices = service === '' ? orderBy(services, 'q', 'desc') : orderBy(filter(services, obj => obj.type !== service), 'q', 'desc')
        this.getFields(possession === false ? editedServices : [])
      } else {
        this.getFields(orderBy(services, 'q', 'desc'))
      }
    },
    resetFilters () {
      this.serviceTypeFilter = ''
      this.possessionFilter = ''
      this.activitySectorFilter = ''
      this.companyFilter = ''
      this.ownerFilter = ''
      this.vehicleStateFilter = ''
      this.ownershipTypeFilter = ''
      this.removedFilter = ''
      this.$refs.vehicleTable.resetSearch()
    },
    fetchData () {
      this.$root.$emit('activeLoader', true)
      return this.getOptions().then(() => this.getVehicle().then(vehicles => {
        this.originalVehicles = vehicles
        const services = this.getServices(vehicles)
        this.getFields(orderBy(services, 'q', 'desc'))
        return this.mergeVehiclesAndFields(vehicles, this.serviceTypeOptions)
      })).catch(r => {
        this.$root.$emit('activeLoader', false)
        return r
      })
    },
    getServices (vehicles) {
      const setServices = new Set()
      const serviceCounter = {}
      const editedArray = []
      if (vehicles && vehicles.length !== 0) {
        vehicles.forEach(vehicle => {
          if (vehicle.services) {
            vehicle.services.forEach(service => {
              serviceCounter[service.type] = { val: serviceCounter[service.type] ? serviceCounter[service.type].val + 1 : 1 }
              setServices.add(service.type)
            })
          }
        })
      }
      setServices.forEach(service => {
        editedArray.push({ id: service, q: serviceCounter[service].val })
      })
      return editedArray
    },
    getOptions () {
      const axiosArray = []
      this.getRemovedOptions()
      this.getPossessionOptions()
      this.getOwnershipTypeOptions()
      this.updateLinks()
      axiosArray.push(this.getEnum('owner', 'ownerOptions'))
      axiosArray.push(this.getEnum('fuel_type', 'fuelsOptions'))
      axiosArray.push(this.getEnum('company', 'companyOptions'))
      axiosArray.push(this.getEnum('equipment', 'equipmentOptions'))
      axiosArray.push(this.getEnum('vehicle_state', 'vehicleStateOptions'))
      axiosArray.push(this.getEnum('activity_sector', 'activitySectorOptions'))
      axiosArray.push(this.getEnum('service_type', 'serviceTypeOptions'))
      axiosArray.push(this.getEnum('classification', 'classificationOptions'))
      axiosArray.push(this.getEnum('registry_code', 'wasteOptions'))
      return Vue.myAll(axiosArray).then(r => r)
    },
    getEnum (path, obj) {
      const options = []

      return Vue.myGet(this, `/enums/${path}`, 'data').then((items) => {
        options.push({ value: '', text: items.length !== 0 ? this.$t('message.selectOption') : this.$t('message.noOption') })
        items.forEach((item) => {
          options.push({ value: item.id, text: item.descr })
        })
        if (obj) {
          this[obj] = options
        }
        return options
      }).catch(error => {
        Vue.manageErrors(this, error, Vue.getDimetiorHttpCode())
        return false
      })
    },
    getRemovedOptions () {
      this.removedOptions = [
        { value: '', text: this.$t('message.all') },
        { value: false, text: this.$t('message.yes') },
        { value: true, text: this.$t('message.no') }
      ]
    },
    getPossessionOptions () {
      this.possessionOptions = [
        { value: '', text: this.$t('message.emptyValue') },
        { value: true, text: this.$t('message.has') },
        { value: false, text: this.$t('message.hasNot') }
      ]
    },
    getOwnershipTypeOptions () {
      this.ownershipTypeOptions = [
        { value: '', text: this.$t('message.selectOption') },
        { value: 'rental', text: this.$tc('message.rental', 1) },
        { value: 'leasing', text: 'Leasing' },
        { value: 'property', text: this.$tc('message.property', 1) },
        { value: 'loan', text: this.$tc('message.loan', 1) }
      ]
    },
    getVehicle () {
      return Vue.myGet(this, '/vehicles?all=true', 'vehicles').then((vehicles) => {
        const editedItems = []
        const activitySectorOptions = this.activitySectorOptions
        const ownerOptions = this.ownerOptions
        const ownershipTypeOptions = this.ownershipTypeOptions
        const vehicleStateOptions = this.vehicleStateOptions
        const companyOptions = this.companyOptions
        const classificationOptions = this.classificationOptions
        const fuelsOptions = this.fuelsOptions
        const equipmentOptions = this.equipmentOptions
        const trackers = this.trackers
        const options = {
          activitySectorOptions,
          ownerOptions,
          ownershipTypeOptions,
          vehicleStateOptions,
          companyOptions,
          classificationOptions,
          fuelsOptions,
          equipmentOptions,
          trackers
        }
        vehicles.forEach(vehicle => {
          const editedVehicle = this.assembleVehicle(vehicle, options)
          editedVehicle.services = vehicle.services || null
          editedItems.push(editedVehicle)
        })
        return editedItems
      }).catch(error => {
        Vue.manageErrors(this, error, Vue.getDimetiorHttpCode())
        return []
      })
    },
    assembleVehicle (vehicle, options) {
      let newVehicle = this.getMainVehicleData(vehicle, options)
      newVehicle = this.getExtraData(vehicle, newVehicle, options)
      newVehicle = this.getVehicleUsage(vehicle, newVehicle, options)
      return newVehicle
    },
    getMainVehicleData (vehicle, options) {
      const classification = find(options.classificationOptions, obj => vehicle.type && vehicle.type.classification !== null && obj.value === vehicle.type.classification)
      const fuel = find(options.fuelsOptions, obj => vehicle.type && vehicle.type.fuelType !== null && obj.value === vehicle.type.fuelType)
      const equipment = find(options.equipmentOptions, obj => vehicle.type && vehicle.type.equipment !== null && obj.value === vehicle.type.equipment)

      return {
        id: vehicle.id,
        name: `${vehicle.plateNumber} ${(vehicle.type && vehicle.type.brand) || ''} ${(vehicle.type && vehicle.type.model) || ''}`,
        plateNumber: vehicle.plateNumber,
        typeBrand: (vehicle.type && vehicle.type.brand) || '',
        typeModel: (vehicle.type && vehicle.type.model) || '',
        registrationDate: vehicle.registrationDate,
        classification: classification && classification.text,
        classificationValue: classification && classification.value,
        chassisNumber: vehicle.chassisNumber,
        payload: vehicle.type && vehicle.type.payload,
        engineDisplacement: vehicle.type && vehicle.type.engineDisplacement,
        kw: vehicle.type && vehicle.type.kw,
        fuel: fuel && fuel.text,
        fuelValue: fuel && fuel.value,
        seats: vehicle.type && vehicle.type.seats,
        emissionStandard: vehicle.type && vehicle.type.emissionStandard,
        trailerHitch: vehicle.type && vehicle.type.trailerHitch ? this.$t('message.yes') : this.$t('message.no'),
        equipment: equipment && equipment.text,
        equipmentValue: equipment && equipment.value
      }
    },
    getExtraData (oldVehicle, vehicle, options) {
      const activitySector = find(options.activitySectorOptions, obj => obj.value === oldVehicle.activitySector && oldVehicle.activitySector !== null)
      const property = find(options.ownerOptions, obj => oldVehicle.ownership && obj.value === oldVehicle.ownership.owner && oldVehicle.ownership.owner !== null)
      const state = find(options.vehicleStateOptions, obj => obj.value === oldVehicle.state && oldVehicle.state !== null)
      const userCompany = find(options.companyOptions, obj => obj.value === oldVehicle.userCompany && oldVehicle.userCompany !== null)
      const measures = oldVehicle.measures && oldVehicle.measures.length && oldVehicle.measures.length !== 0 ? last(oldVehicle.measures) : {}

      vehicle.disabledText = oldVehicle.disablingDate ? this.$t('message.no') : this.$t('message.yes')
      vehicle.disabledDate = oldVehicle.disablingDate ? oldVehicle.disablingDate : this.$t('message.noDate')
      vehicle.disabledValue = !!oldVehicle.disablingDate
      vehicle.stateText = state && state.text
      vehicle.stateValue = state && state.value
      vehicle.property = property && property.text
      vehicle.propertyValue = property && property.value
      vehicle.userCompanyText = userCompany && userCompany.text
      vehicle.userCompanyValue = userCompany && userCompany.value
      vehicle.activitySectorText = activitySector && activitySector.text
      vehicle.activitySectorValue = activitySector && activitySector.value
      vehicle.kmCost = oldVehicle.kmCost
      vehicle.avgConsumption = oldVehicle.avgConsumption
      vehicle.lengthCm = oldVehicle.type && oldVehicle.type.length
      vehicle.widthCm = oldVehicle.type && oldVehicle.type.width
      vehicle.traction = oldVehicle.type && oldVehicle.type.traction // was changed in maxWeight
      vehicle.lastKm = measures && measures.km
      vehicle.lastDate = measures && measures.date
      vehicle.automathicKm = oldVehicle.estimatedKm
      vehicle.automathicDate = `${DateTime.local().plus({ days: -1 }).toSQLDate()} 00:00:00`
      vehicle.description = oldVehicle.description
      return cloneDeep(vehicle)
    },
    getVehicleUsage (oldVehicle, vehicle, options) {
      const ownershipObj = this.getOwnershipType(cloneDeep(oldVehicle.ownership), options)
      const rental = oldVehicle.ownership && oldVehicle.ownership.rental
      const leasing = oldVehicle.ownership && oldVehicle.ownership.leasing
      const purchase = oldVehicle.ownership && oldVehicle.ownership.purchase
      vehicle.ownership = ownershipObj && ownershipObj.name
      vehicle.ownershipValue = ownershipObj && ownershipObj.ownershipValue
      vehicle.rentalStart = rental && rental.startDate && rental.type !== 'loan' ? rental.startDate : this.$t('message.noDate')
      vehicle.rentalEnd = rental && rental.endDate && rental.type !== 'loan' ? rental.endDate : this.$t('message.noDate')
      vehicle.loanStart = rental && rental.startDate && rental.type === 'loan' ? rental.startDate : this.$t('message.noDate')
      vehicle.loanEnd = rental && rental.endDate && rental.type === 'loan' ? rental.endDate : this.$t('message.noDate')
      vehicle.leasingStart = leasing && leasing.startDate ? leasing.startDate : this.$t('message.noDate')
      vehicle.leasingEnd = leasing && leasing.endDate ? leasing.endDate : this.$t('message.noDate')
      vehicle.purchaseDate = purchase && purchase.date ? purchase.date : null
      vehicle.company = rental && rental.company
      vehicle.rentalPrice = rental && rental.price
      vehicle.rentalRedemptionPrice = rental && rental.redemptionPrice
      vehicle.relief = rental && rental.relief
      vehicle.kmYear = rental && rental.kmYear
      vehicle.maxKm = rental && rental.maxKm
      vehicle.loanerVehicle = rental && rental.type === 'loan' ? this.$t('message.yes') : this.$t('message.no')
      vehicle.towTruck = rental && rental.towTruck ? this.$t('message.yes') : this.$t('message.no')
      vehicle.leasingRedemptionPrice = leasing && leasing.redemptionPrice
      vehicle.purchasePrice = purchase && purchase.price
      vehicle.purchaseKm = purchase && purchase.km
      return cloneDeep(vehicle)
    },
    getOwnershipType (ownership, options) {
      if (ownership) {
        let name = null
        const rentalType = ownership.rental && ownership.rental.type
        const rentalStart = ownership.rental && ownership.rental.startDate && DateTime.fromSQL(ownership.rental.startDate)
        const leasingStart = ownership.leasing && ownership.leasing.startDate && DateTime.fromSQL(ownership.leasing.startDate)
        const rentalEnd = ownership.rental && ownership.rental.endDate && DateTime.fromSQL(ownership.rental.endDate)
        const leasingEnd = ownership.leasing && ownership.leasing.endDate && DateTime.fromSQL(ownership.leasing.endDate)
        const purchaseStart = ownership.purchase && ownership.purchase.date && DateTime.fromSQL(ownership.purchase.date)
        let ownershipValue = null
        if (purchaseStart) name = this.$tc('message.property', 1)
        if (!name && rentalEnd > leasingEnd) name = rentalType === 'rental' ? this.$tc('message.rental', 1) : this.$t('message.loan')
        if (!name && leasingEnd > rentalEnd) name = 'Leasing'
        if (!name && leasingEnd) name = 'Leasing'
        if (!name && rentalEnd) name = rentalType === 'rental' ? this.$tc('message.rental', 1) : this.$t('message.loan')
        if (name) {
          ownershipValue = find(options.ownershipTypeOptions, obj => obj.text === name).value
        }
        return {
          ownershipValue,
          name,
          rentalStart,
          rentalEnd,
          leasingStart,
          leasingEnd,
          purchaseDate: purchaseStart
        }
      }
      return null
    },
    getFields (services) {
      const basicFields = [
        // config[crud], create - read - update - delete
        { key: 'edit', label: '', hideInTable: !this.config.u && !this.config.r },
        { key: 'name', label: `${this.$tc('message.vehicle', 1)}`, sortable: true, sortDirection: 'desc' },
        { key: 'activitySectorText', label: `${this.$tc('message.sector', 1)} ${this.$tc('message.activity', 1).toLowerCase()}`, sortable: true, sortDirection: 'desc' },
        { key: 'userCompanyText', label: this.$tc('message.society', 1), sortable: true, sortDirection: 'desc' },
        { key: 'property', label: this.$tc('message.property', 1), sortable: true, sortDirection: 'desc' },
        { key: 'ownership', label: this.$t('message.vehicleUsage'), sortable: true, sortDirection: 'desc' },
        { key: 'disabledText', label: `${this.$t('message.inOperation')}`, sortable: true, sortDirection: 'desc' },
        { key: 'stateText', label: this.$tc('message.status', 1), sortable: true, sortDirection: 'desc' }
      ]
      const customFields = []
      let firstInjectionColumnIndex = 2
      services.forEach(service => {
        const foundedService = find(this.serviceTypeOptions, obj => obj.value === service.id)
        if (foundedService) {
          customFields.push({ key: service.id, label: foundedService.text, sortable: true, sortDirection: 'desc', position: firstInjectionColumnIndex })
          firstInjectionColumnIndex += 1
        }
      })
      this.fields = basicFields
      this.customFields = customFields
      return this.fields
    },
    mergeVehiclesAndFields (vehicles, services) {
      const editedVehicles = []
      vehicles.forEach(vehicle => {
        const editedItem = vehicle
        services.forEach(service => {
          const foundedServiceInVehicle = find(vehicle.services, obj => obj.type === service.value)
          if (foundedServiceInVehicle) {
            editedItem[service.value] = foundedServiceInVehicle.expDate
              ? DateTime.fromSQL(foundedServiceInVehicle.expDate).toFormat('dd-MM-yyyy') : this.$tc('message.yes', 1)
          } else {
            editedItem[service.value] = this.$tc('message.no', 1)
          }
        })
        editedVehicles.push(editedItem)
      })
      this.originalItems = orderBy(editedVehicles, 'name')
      this.items = cloneDeep(this.originalItems)
      this.$root.$emit('activeLoader', false)
      return this.items
    },
    handleExcel (fileName) {
      return this.$refs.vehicleTable.excel(fileName, this.$refs.vehicleTable.componentFields)
    },
    updateLinks () {
      const links = []
      this.links.forEach(link => {
        links.push({ href: link })
      })
      this.$root.$emit('change-links', links)
    }
  }
}
</script>
